export default __webpack_public_path__ + "static/media/chevrons-up-down-24.7d39f45f.svg";